import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Indent.svg'

export const IconIndent = IconSVG as IconComponent
